'use strict';

exports.__esModule = true;

var _regeneratorRuntime = require('regenerator-runtime');

var _regeneratorRuntime2 = _interopRequireDefault(_regeneratorRuntime);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _db = require('@swarm/db');

var _db2 = _interopRequireDefault(_db);

var _ronUuid = require('@swarm/ron-uuid');

var _ronUuid2 = _interopRequireDefault(_ronUuid);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // for async/await work flow

var GraphQL = function (_React$Component) {
  _inherits(GraphQL, _React$Component);

  function GraphQL(props, context) {
    _classCallCheck(this, GraphQL);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.swarm = context.swarm || _this.props.swarm;
    (0, _invariant2.default)(_this.swarm, 'Could not find "swarm" in either the context or ' + 'props of <GraphQL>. ' + 'Either wrap the root component in a <Provider>, ' + 'or explicitly pass "swarm" as a prop to <GraphQL>.');

    _this._unmounted = false;
    _this.state = {
      data: null,
      mutations: _this._bindMutations(),
      initialized: _this.swarm ? _this.swarm.client.queue === undefined : false
    };

    if (_this.swarm) {
      _this.swarm.ensure().then(function () {
        _this._subscribe();
        _this.setState({ initialized: true });
      }).catch(function (error) {
        !_this._unmounted && _this.setState({ error: error });
      });
    }
    return _this;
  }

  GraphQL.prototype.componentDidUpdate = function componentDidUpdate(prev) {
    if (this.props.query !== prev.query || !shallowEqual(this.props.variables, prev.variables) || !shallowEqual(this.props.mutations, prev.mutations)) {
      this._unsubscribe();
      !this._unmounted && this.setState({
        data: null,
        error: undefined,
        mutations: this._bindMutations()
      }, this._subscribe.bind(this));
    }
  };

  GraphQL.prototype.componentWillUnmount = function componentWillUnmount() {
    this._unmounted = true;
    this._unsubscribe();
  };

  GraphQL.prototype._subscribe = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee() {
      var _this2 = this;

      var _props, query, variables, swarm, sub;

      return _regeneratorRuntime2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props = this.props, query = _props.query, variables = _props.variables, swarm = this.swarm;

              if (!(!swarm || !swarm.execute || !query)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              _context.next = 5;
              return swarm.execute({ query: query, variables: variables }, function (r) {
                !_this2._unmounted && _this2.setState({ data: r.data, error: r.error });
              });

            case 5:
              sub = _context.sent;


              if (this._off) this._off();
              this._off = sub.off;

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function _subscribe() {
      return _ref.apply(this, arguments);
    }

    return _subscribe;
  }();

  GraphQL.prototype._unsubscribe = function _unsubscribe() {
    this._off && this._off();
  };

  GraphQL.prototype._bindMutations = function _bindMutations() {
    var _this3 = this;

    var mutations = this.props.mutations,
        swarm = this.swarm;

    var ret = {};
    if (mutations && swarm) {
      var _loop = function _loop(key) {
        ret[key] = function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime2.default.mark(function _callee2(variables) {
            return _regeneratorRuntime2.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt('return', new Promise(function (resolve, reject) {
                      swarm.execute({ query: mutations[key], variables: variables }, function (r) {
                        r.error ? reject(r.error) : resolve(r.data);
                      });
                    }));

                  case 1:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _callee2, _this3);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }();
      };

      for (var _iterator = Object.keys(mutations), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref2;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref2 = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref2 = _i.value;
        }

        var key = _ref2;

        _loop(key);
      }
    }
    return ret;
  };

  GraphQL.prototype.render = function render() {
    return this.props.children && this.props.children.call(null, {
      data: this.state.data,
      uuid: this.state.initialized && this.swarm ? this.swarm.uuid : null,
      error: this.state.error,
      mutations: this.state.mutations
    });
  };

  return GraphQL;
}(React.Component);

exports.default = GraphQL;


GraphQL.contextTypes = {
  swarm: _propTypes2.default.shape({}).isRequired
};

function shallowEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  var aKeys = Object.keys(a);
  if (Object.keys(b).length !== aKeys.length) return false;
  for (var _iterator2 = aKeys, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref4;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref4 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref4 = _i2.value;
    }

    var key = _ref4;

    if (a[key] !== b[key]) return false;
  }
  return true;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/react/lib/GraphQL.js
// module id = 121
// module chunks = 0